import { STATUS_LABEL } from "@/constants/enum";
import { TOption } from "@/types/common";
import { EIndustryExamType } from "@/types/enum";

export const EXAM_STATUS_OPTIONS: TOption[] = [
  { label: "有効", value: "active" },
  { label: STATUS_LABEL.ENDED, value: "ended" },
  { label: STATUS_LABEL.DISABLED, value: "inactive" },
];

export const EXAM_METHOD_OPTIONS: TOption[] = [
  { label: "CBT", value: "cbt" },
  { label: "ペーパーテスト", value: "paper_test" },
];

/** Map API status to display label */
export const EXAM_STATUS_LABEL: Record<string, string> = {
  active: "有効",
  ended: STATUS_LABEL.ENDED,
  inactive: STATUS_LABEL.DISABLED,
};

/** Map API exam method to display label (short) */
export const EXAM_METHOD_LABEL: Record<string, string> = {
  cbt: "予約制 (CBT)",
  paper_test: "固定",
};

/** Map exam type enum to display label for list table */
export const EXAM_TYPE_LABELS: Record<EIndustryExamType, string> = {
  [EIndustryExamType.PAPER_TEST]: "PT方式",
  [EIndustryExamType.CBT]: "CBT方式",
};

export const EXAM_PROCEDURE_AGENT_OPTIONS: TOption[] = [
  { label: "受験者", value: "applicant" },
  { label: "所属機関", value: "affiliated_organization" },
  { label: "受験者または所属機関", value: "applicant_or_organization" },
];
